export function isValidCssColor(val: string | undefined) {
  if (val === undefined) return false;
  var style = new Option().style;
  if (style.color !== '') return false;
  style.color = val;
  return style.color !== '';
}
